import React, { useCallback, useEffect, useState } from 'react';

import { Flex, Grid, GridItem } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { useSelector, useDispatch } from 'react-redux';
import { getRelationToLoggedInEmployeeApi } from 'screens/oneOnOneRabbit/InstancePage/apis';
import { selectLoggedInEmployeeId } from 'selectors/loggedInEmployee';

import { Paper } from 'uiToolkitV1/Paper';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

import SearchEmployees from './SearchEmployees';
import { updateParticipantId, updateRelation, useCreateOneOnOneDrawerData } from './slice/CreateOneOnOneDrawerSlice';

const Container = styled(Paper)`
  width: 100%;
  padding: 16px 20px;
  margin-bottom: 4px;
`;

export const RELATION_MAP = {
  REPORTEE: 'Reportee',
  MANAGER: 'Manager',
  PEER: 'Peer',
  SKIP_REPORTEE: 'Skip Reportee',
  SKIP_MANAGER: 'Skip Manager',
};

const ParticipantSelectionComp = ({ excludedParticipantIds = [], employeeMiniProfile }) => {
  const { participantId } = useCreateOneOnOneDrawerData();
  const dispatch = useDispatch();

  const loggedInEmployeeId = useSelector(selectLoggedInEmployeeId);

  const [relation, setRelation] = useState(null);
  const employeeId = participantId ?? employeeMiniProfile?.id;

  const onSelect = useCallback((selectedEmployeeId) => {
    dispatch(updateParticipantId(selectedEmployeeId ?? employeeId));
  }, []);

  const onClear = useCallback(() => {
    dispatch(updateParticipantId(null));
  }, []);

  useEffect(() => {
    if (employeeId) {
      getRelationToLoggedInEmployeeApi({ employeeId }).then((res) => {
        setRelation(RELATION_MAP[res.entity]);
        dispatch(updateRelation(RELATION_MAP[res.entity]));
      });
    } else {
      setRelation(null);
    }
  }, [participantId, employeeId]);

  return (
    <Container>
      <Grid templateColumns="2fr 1fr" gridColumnGap={12}>
        <GridItem>
          <Flex flexDir="column" alignItems="flex-start">
            <TextLabel color="text.g2">Select Participant</TextLabel>
            <SearchEmployees
              exclusions={[loggedInEmployeeId, ...excludedParticipantIds]}
              onSelect={onSelect}
              employeeMiniProfile={employeeMiniProfile}
              onClear={onClear}
            />
          </Flex>
        </GridItem>
        <GridItem>
          <Flex flexDir="column" alignItems="flex-start">
            <TextLabel color="text.g2">Relationship</TextLabel>
            <TextBodyMedium mt={2}>{relation ?? '--'}</TextBodyMedium>
          </Flex>
        </GridItem>
      </Grid>
    </Container>
  );
};

export default ParticipantSelectionComp;
